/**
 * Generate streaming URL for organization logo via the proxy endpoint.
 * Works for both Azure blob and S3 URLs.
 */
export const streamOrganizationLogo = (logoUrl: string): string => {
  const fileName = logoUrl.split('/').pop();

  if (!fileName) {
    throw new Error('Invalid logo URL');
  }

  return `/api/projects/logo/${encodeURIComponent(fileName)}`;
};

/**
 * Check if a URL is a cloud storage URL that should be proxied through the
 * server streaming endpoint (both Azure blob and S3 are supported).
 */
export const isCloudStorageUrl = (url: string): boolean => {
  return (
    url.includes('.blob.core.windows.net/') ||
    url.includes('.s3.amazonaws.com/') ||
    url.includes('.s3.') // covers virtual-hosted and path-style S3 URLs
  );
};

/** @deprecated Use isCloudStorageUrl instead */
export const isAzureBlobUrl = isCloudStorageUrl;

/**
 * Get the appropriate logo URL for display.
 * Cloud storage URLs are proxied through the server; other URLs are returned as-is.
 */
export const getDisplayLogoUrl = (logoUrl: string): string => {
  if (isCloudStorageUrl(logoUrl)) {
    return streamOrganizationLogo(logoUrl);
  }
  return logoUrl;
};
